import initBackDropWithImages from './components/backdrop';
import initReviews from './components/reviews';
import initMobileMenu from './components/mobile-menu';
import initCaveVideoGroups from './components/video-group';

const preferReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

initBackDropWithImages(preferReduceMotion);
initReviews();
initMobileMenu();
initCaveVideoGroups();
